import Vue from 'vue'
import App from './App'
import router from './router'

/* import icon of svg */
import './assets/icon'

import './components/notice/index.js'

/* import store */
import Store from './api/store'

Vue.config.productionTip = false

Vue.prototype.$store = Store

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js